<template>
<v-dialog v-model="DisplayDialog" transition="dialog-bottom-transition" max-width="500px" persistent @keydown.esc="Confirmed()">
    <v-card>
        <v-card-title class="headline">{{DialogTitle}}</v-card-title>
        <v-card-text>
            {{DialogContents}}
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="Yes()">Yes</v-btn>
            <v-btn color="success" @click="No()">No</v-btn>
            <v-btn color="error" @click="Cancel()">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
export default {
    props: {
        DisplayDialog: {
            type: Boolean,
            required: true
        },
        DialogTitle: {
            type: String,
            required: false
        },
        DialogContents: {
            type: String,
            required: true
        }
    },
    methods: {
        Yes() {
            this.$emit("ClickedYes");
        },
        No() {
            this.$emit("ClickedNo");
        },
        Cancel() {
            this.$emit("ClickedCancel")
        }
    }
}
</script>
